import { render, staticRenderFns } from "./market-evolution.page.vue?vue&type=template&id=1dd28c2c&scoped=true"
import script from "./market-evolution.page.vue?vue&type=script&lang=ts"
export * from "./market-evolution.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd28c2c",
  null
  
)

export default component.exports